module.exports = {
  SIGN_IN: 'साइन इन करें',
  UNDER_DEVELOPMENT: 'विकास जारी है',
  HOME: 'होम',
  DASHBOARD: 'डैशबोर्ड',
  WORKFLOW: 'वर्कफ़्लो',
  DOCUMENTS: 'डॉक्यूमेंट',
  ACCOUNT: 'खाता',
  DESIGN: 'डिजाईन',
  DEMO: 'डेमो',
  SETTINGS: 'सेटिंग्स',
  LEEGALITY_DASHBOARD: 'लीगैलिटी डैशबोर्ड',
  MY_ACCOUNT: 'मेरा खाता',
  PROVISIONS: 'प्रावधान',
  PROFILE: 'प्रोफ़ाइल',
  SIGNATURES: 'हस्ताक्षर',
  ID: 'आईडी',
  GENDER: 'लिंग',
  COMMUNICATION_ADDRESS: 'संचार पता',
  BILLING_ADDRESS: 'बिलिंग पता',
  PLAN: 'योजना',
  TEAM: 'दल',
  BALANCE: 'शेष राशि',
  LANGUAGES: 'भाषाएं',
  HINDI: 'हिन्दी',
  ENGLISH: 'अंग्रेज़ी',
  CANCEL: 'रद्द करें',
  DELETE: 'हटा दें',
  CONFIRM: 'पुष्टि करें',
  DISCARD: 'रद्द करें',
  SAVE_CHANGES: 'बदलाव सेव करें',
  LEARN_MORE: 'और जानें',
  DISMISS: 'ख़ारिज करें',
  SELECT_DATE: 'तारीख़ चुने',
  DTP_LAST_7_DAYS: 'आखिरी 7 दिन',
  DTP_LAST_30_DAYS: 'आखिरी 30 दिन',
  DTP_THIS_MONTH: 'इस महीने',
  DTP_LAST_MONTH: 'पिछले महीने',
  DTP_TODAY: 'आज',
  DTP_YESTERDAY: 'बिता कल',
  DTP_CANCEL: 'रद्द करें',
  DTP_APPLY: 'लागू करें',
  DTP_FROM: 'से',
  DTP_TO: 'तक',
  DTP_CUSTOM: 'स्वादानुसार',
  LEEGALITY_COPYRIGHTS: 'कॉपीराइट © 2022 लीगैलिटी',

  MSG_WELCOME: 'लीगैलिटी फ्रंटएंड में आपका स्वागत है',
  MSG_LANDING_PAGE: 'यह वेब-ऐप का लैंडिंग पेज है। यह "/" (रूट) पथ पर मैप करता है।',
  MSG_GO_TO_SIGN_IN: 'साइन-इन पर जाएं',
  MSG_GO_TO_SIGN_UP: 'साइन-अप पर जाएं',
  MSG_GO_TO_DASHBOARD: 'डैशबोर्ड पर जाएं',
  MSG_UNDER_CONSTRUCTION: 'हम आपके लिए कुछ बेहतरीन बना रहे हैं। \nबने रहें!',
  MSG_SIGN_IN_PAGE: 'यह साइन-इन पेज है',
  MSG_CLICK_TO_GO_TO_DASHBOARD: 'डैशबोर्ड पर जाने के लिए बटन पर क्लिक करें।',
  MSG_VAL_TEXT_NOT_EMPTY: '{label} एक अनिवार्य इनपुट है',
  MSG_VAL_TEXT_NOT_EMPTY_NO_SPACE: '{label} एक अनिवार्य इनपुट है और इसमें रिक्त स्थान नहीं हो सकते हैं',
  MSG_VAL_TEXT_MIN_CHAR_COUNT: 'कम से कम {text_min_char_count} वर्ण होने चाहिए',
  MSG_VAL_TEXT_MAX_CHAR_COUNT: 'अधिकतम {text_max_char_count} वर्ण होने चाहिए',
  MSG_VAL_TEXT_NUMBER: 'कृपया एक सही संख्या डालिये',
  MSG_VAL_TEXT_ALL_NO_NUMBER: 'कृपया पाठ से संख्याएं हटा दें',
  MSG_VAL_TEXT_EMAIL: 'कृपया एक मान्य ईमेल पता दर्ज करें',
};
